import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  PaginationControls,
  Text,
} from '@shared/ui';

export function PaginationShowcase() {
  const { t } = useTranslation();
  const totalItems = 100;
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.navigation.pagination.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.navigation.pagination.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-5">
        {(['default', 'touch', 'adaptive'] as const).map((size) => (
          <div key={size} className="space-y-2">
            <Text size="sm" color="muted">
              <code>{`size="${size}"`}</code>
            </Text>
            <PaginationControls
              size={size}
              totalItems={totalItems}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              labels={{
                showing: (from, to, total) =>
                  t('uiLibrary.navigation.pagination.showing', {
                    from,
                    to,
                    total,
                  }),
                page: t('uiLibrary.navigation.pagination.pageLabel'),
                of: (totalPages) =>
                  t('uiLibrary.navigation.pagination.ofLabel', { total: totalPages }),
                previous: t('common.previous'),
                next: t('common.next'),
              }}
            />
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
